import { createContext } from 'react';

const DEFAULT_VALUES = {
};

export const ActivityContext = createContext(DEFAULT_VALUES);
